import React from 'react'
import PropTypes from 'prop-types'

import VendorFilters from 'ui/modules/emptyState/vendorFilters'
import NoVendor from 'ui/modules/emptyState/noVendors'
import SimpleError500 from 'ui/modules/emptyState/error500'
import SimpleNoFiled from 'ui/modules/emptyState/noFiled'
import NoVendorSearch from 'ui/modules/emptyState/noVendorsSearch'

const EmptyStateManager = ({ type = 'server', action }) => {
  if (type === 'noResultsFilter') {
    return <VendorFilters onClick={action} />
  }

  if (type === 'noResults') {
    return <NoVendor onClick={action} />
  }

  if (type === 'noResultsSearchDetail') {
    return <NoVendorSearch />
  }

  if (type === 'noSearches') {
    return <SimpleNoFiled />
  }

  return <SimpleError500 />
}

EmptyStateManager.propTypes = {
  type: PropTypes.oneOf([
    'server',
    'noResults',
    'noResultsFilter',
    'noResultsSearchDetail',
    'noSearches',
  ]),
  action: PropTypes.func,
}

export default EmptyStateManager
